import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  Tooltip,
  Menu,
  IconButton,
  Checkbox,
  FormControl,
  Autocomplete,
  ListSubheader,
  Dialog,
  DialogContent,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useLocation, useNavigate } from "react-router-dom";
import { CiFilter } from "react-icons/ci";
import SearchBar from "../../SearchBar";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import { fetchEntityById, newFilterEntities,  postResource,} from "../../../apis/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { extractTextFromHTML } from "../../../utils/textUtils";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setTasklistDatas } from "../../../selectSlice";
import Loader from "../../common/Loader";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import {
  useFetchMilestoneTasksQuery,
  useFetchTaskListsQuery,
  useFetchTaskNameByIdQuery,
} from "../../../slice/logdetailSlice";
import CommonDeleteDialog from "../../common/CommonDelete";
import { CommonAddTaskTab } from "../../common/Task/CommonAddTaskTab";
import Movetask from "../../common/Task/Movetask";
import { hasTaskPermission } from "../../../utils/Permissions";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import useTaskTimer from "../../../assets/hooks/UseTaskTimer";
import { FilterSummaryBox } from "../../common/FilterSummaryBox";
import dayjs from "dayjs";
import CommonTaskIssueNameChamge from "../../common/CommonTaskIssueNameChamge";
import SubtaskBoard from "./SubtaskBoard";
import { SubtaskBoardFilter } from "./SubtaskBoardfilter";
import { useTheme } from "../../../ThemeContext";
import { openInNewTab } from "../../../utils/openInNewTab";


export const TaskFilterComponent = ({
  onApply,
  onClear,
  onCancel,
  filterid,
  isMilestoneTask,
  project_id,
  milestone_id,
  filter_path,
  isSubtask,
  task_list_id,
}) => {

  const [filters, setFilters] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const project_id = localStorage.getItem("project_id");

  // const { data: projectNames } = useFetchTaskNameByIdQuery(project_id, {
    // const { data: projectNames, refetch: refetchProjectTasks } = useFetchTaskNameByIdQuery(project_id, {
  const { 
    data: projectNames, 
    refetch: refetchProjectTasks,
    isUninitialized: isProjectTasksUninitialized,
    isLoading: isProjectTasksLoading
  } = useFetchTaskNameByIdQuery(project_id, {
    skip: !project_id,
  });

  const usersInProjects = useSelector(
    (state) => state.selectOptions?.userNamesByProjects
  );
  // console.log("userNamesByProjects", usersInProjects);
  // const { data: taskNames } = useFetchMilestoneTasksQuery(milestone_id, {
    // const { data: taskNames, refetch: refetchMilestoneTasks } = useFetchMilestoneTasksQuery(milestone_id, {
  const { 
    data: taskNames, 
    refetch: refetchMilestoneTasks,
    isUninitialized: isMilestoneTasksUninitialized,
    isLoading: isMilestoneTasksLoading
  } = useFetchMilestoneTasksQuery(milestone_id, {
    skip: !milestone_id,
  });

  // Automatically refetch task names when filter opens to show newly added tasks
  useEffect(() => {
    // Robust Triple-Guard pattern for project tasks
    if (typeof refetchProjectTasks === "function" && !isProjectTasksUninitialized && !isProjectTasksLoading) {
      try {
        refetchProjectTasks();
      } catch (e) {
        console.debug("Safe refetch guard handled early call for Project Tasks");
      }
    }
    // Robust Triple-Guard pattern for milestone tasks
    if (typeof refetchMilestoneTasks === "function" && !isMilestoneTasksUninitialized && !isMilestoneTasksLoading) {
      try {
        refetchMilestoneTasks();
      } catch (e) {
        console.debug("Safe refetch guard handled early call for Milestone Tasks");
      }
    }
  }, 
  [project_id, milestone_id, 
    isProjectTasksUninitialized, 
    isMilestoneTasksUninitialized, 
    isProjectTasksLoading, 
    isMilestoneTasksLoading, 
    refetchProjectTasks, 
    refetchMilestoneTasks
  ]);

  const activestatus = useSelector((state) => state.selectOptions.StatusOptions);
  const activityStatus = activestatus.find((status) => status.status_type === "TASK");
  const statusList = activityStatus?.status_details.map((status) => ({
    id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));
  // const statusLists= statusOptions.map
  // console.log("task filter status : ", statusList);
  const sessionFilteredData = sessionStorage.getItem("task_filter_data");
  const filterDatas = JSON.parse(sessionFilteredData);
  const { handleSubmit, control, reset, setValue, formState: { errors } } = useForm({
    defaultValues: {
      taskTitle: filterDatas?.title || [],
      // owner: filterDatas?.project_manager_id || "",
      owner: filterDatas?.owner || "",
      createdBy: filterDatas?.added_by || "",
      // createdDate: filterDatas?.added_at ? filterDatas.added_at : null,
      createdDate: filterDatas?.added_at ? dayjs(filterDatas.added_at) : null,
      lastModifiedBy: filterDatas?.updated_by || "",
      startDate: filterDatas?.start_date
        ? dayjs(filterDatas?.start_date)
        : null,
      endDate: filterDatas?.end_date ? dayjs(filterDatas?.end_date) : null,
      status: filterDatas?.current_status_id || "",
      billingType: filterDatas?.billing_type || "",
    },
  });
  // console.log("Watched Value:", watch("status"));

  const onSubmit = async (data) => {
    const hasActiveFilter = 
      (data.taskTitle && data.taskTitle.length > 0) ||
      data.owner ||
      data.startDate ||
      data.endDate ||
      data.billingType ||
      data.createdBy ||
      data.status ||
      data.createdDate ||
      data.lastModifiedBy;

    if (!hasActiveFilter) {
      toast.info("No filter values selected. Select one or more filters to apply");
      return;
    }

    // console.log("taskFilter Data :", data);
    const requestedData = {
      view_type_id: filterid,
      title: data.taskTitle, // Assuming you want the first selected title
      owner: parseInt(data.owner, 10) || null, // Ensure numeric ID
      start_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      end_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
      // billing_type: data.billingType || null,
      billing_type: data.billingType === "NON_BILLABLE" ? "NON-BILLABLE" : data.billingType || null,
      added_by: parseInt(data.createdBy, 10) || null,
      current_status_id: data.status || null,
      added_at: data.createdDate
        ? format(new Date(data.createdDate), "yyyy-MM-dd")
        : null,
      updated_by: data.lastModifiedBy
        ? parseInt(data.lastModifiedBy, 10)
        : null,
      // updated_at: data.endDate,
      // filter: data.filter, // Array of selected user IDs
    };

    setIsSubmitting(true);
    try {
      const response = await newFilterEntities(
        filter_path,
        isMilestoneTask ? milestone_id : isSubtask ? task_list_id : project_id,
        requestedData
      );
      setFilters(response);
      // console.log("filter data :", filters);
      // if (response.data) {
         if (response.data && response.data.length > 0) {
        // onApply(response.data);
        // sessionStorage.setItem("");
        sessionStorage.setItem("isTaskFilterApplied", true);
        sessionStorage.removeItem("isFilterApplied");
        sessionStorage.setItem(
          "task_filter_data",
          JSON.stringify(requestedData)
        );
        onApply(response.data);
        toast.success("Task filter applied successfully!");
      } 
      else {
      //   toast.error(response.message);
      // }
      // console.log(" filter response data:", response.data);
        // onApply([]);
        sessionStorage.setItem("isTaskFilterApplied", true);
        sessionStorage.removeItem("isFilterApplied");
        sessionStorage.setItem(
          "task_filter_data",
          JSON.stringify(requestedData)
        );
        onApply([]);
        toast.info("No data found");
      }
    } 
    catch (err) {
      const errorMessage = err.message || "Failed to fetch projects.";
      // console.error("Error fetching filtered projects:", err);
      toast.error(errorMessage);
    } 
    finally {
      setIsSubmitting(false);
    }
  };

  const handleClear = () => {
    // reset();
        reset({
      taskTitle: [],
      owner: "",
      createdBy: "",
      createdDate: null,
      lastModifiedBy: "",
      startDate: null,
      endDate: null,
      status: "",
      billingType: "",
    });
    if (onClear) onClear();
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red clear-filter-btn"
          >
            Clear Filter
          </button>
        </div>
      </div>
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              {/* Previous layout commented for reference */}
              {/* <div className="row mb-3">
                <div className="col-12">
                  <label htmlFor="taskTitle" className="form-label">
                    Search By Task
                  </label>
                  ...
                </div>
              </div> */}

              {/* Row 1: Search By Task */}
              <div className="row mb-3">
                <div className="col-12">
                  <label htmlFor="taskTitle" className="form-label">Search By Task</label>
                  <Controller
                    name="taskTitle"
                    control={control}
                    render={({ field: { onChange, value } }) => {
                      const options = isMilestoneTask
                        ? Array.isArray(taskNames)
                          ? taskNames
                          : []
                        : Array.isArray(projectNames)
                        ? projectNames
                        : [];

                      const selectedOptions = (value || [])
                        .map((title) =>
                          options.find((item) => item.title === title)
                        )
                        .filter(Boolean);

                      return (
                        <Autocomplete
                          multiple
                          id="taskTitle"
                          popupIcon={<ExpandMore />}
                          options={options}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.title}
                          value={selectedOptions}
                          onChange={(event, newValue) => {
                            const selectedTitles = newValue.map(
                              (item) => item.title
                            );
                            onChange(selectedTitles);
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li
                              {...props}
                              className="d-flex align-items-center mb-2"
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <strong>{option.title}</strong>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search by task"
                            />
                          )}
                          ListboxProps={{
                            style: {
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: "8px",
                              paddingLeft: "0",
                            },
                          }}
                        />
                      );
                    }}
                  />
                </div>
              </div>

              {/* Row 2: Owner & Created Date */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="owner" className="form-label">
                    Owner
                  </label>
                  <Controller
                    control={control}
                    name="owner"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          labelId="owner-label"
                          id="owner"
                          IconComponent={ExpandMore}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects.find(
                                (owner) => owner.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select owner</span>
                            )
                          }
                        >
                          {usersInProjects.map((ownerName) => (
                            <MenuItem
                              key={ownerName.user_id}
                              value={ownerName.user_id}
                            >
                              {ownerName.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                
                <div className="col-md-6">
                  <label htmlFor="createdDate" className="form-label">
                    Created Date
                  </label>
                  <Controller
                    name="createdDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          sx={{ width: '100%' }} // Ensure full width
                          renderInput={(params) => (
                            <input
                              className="form-control datepic_ip"
                              {...params}
                            />
                          )}
                        />
                        {errors.createdDate && (
                          <span className="errorMsg">
                            {errors.createdDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
              </div>

              {/* Row 3: Created By & Last Modified By */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="createdBy" className="form-label">
                    Created By
                  </label>
                  <Controller
                    control={control}
                    name="createdBy"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects.find(
                                (user) => user.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          labelId="createdBy-label"
                          id="createdBy"
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {usersInProjects.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="lastModifiedBy" className="form-label ">
                    Last Modified By
                  </label>
                  <Controller
                    control={control}
                    name="lastModifiedBy"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          labelId="lastModifiedBy-label"
                          id="lastModifiedBy"
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects.find(
                                (statusName) => statusName.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                          IconComponent={ExpandMore} // Add the custom icon here
                        >
                          {usersInProjects.map((user, index) => (
                            <MenuItem key={index} value={user.user_id}>
                              {user.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              {/* Row 4: Start Date & End Date */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">Start Date</label>
                  <Controller
                    name="startDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          sx={{ width: '100%' }}
                          renderInput={(params) => (
                              <input
                                className="form-control datepicker_input"
                                {...params}
                              />
                          )}
                        />
                        {errors.startDate && (
                          <span className="errorMsg">
                            {errors.startDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">End Date</label>
                  <Controller
                    name="endDate"
                    control={control}
                    rules={{
                      validate: (val) => {
                        if (!val) return true;
                        const d = dayjs(val);
                        if (!d.isValid()) return "Invalid date";
                        if (d.year() < 1900) return "Invalid date format";
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <>
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          onChange={(date) => field.onChange(date)}
                          sx={{ width: '100%' }}
                          renderInput={(params) => (
                              <input
                                className="form-control datepic_ip"
                                {...params}
                              />
                          )}
                        />
                        {errors.endDate && (
                          <span className="errorMsg">
                            {errors.endDate.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
              </div>

              {/* Row 5: Status & Billing Type */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="status"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={field.value || ""}
                          onChange={(e) => {
                            field.onChange(e.target.value); // Update form state
                            setValue("status", e.target.value); // Optionally set value
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            const selectedValue = statusList?.find(
                              (statusName) => statusName.id === selected
                            );
                            return selectedValue ? (
                              <span
                                style={{ color: selectedValue.status_colour }}
                              >
                                {selectedValue.status_name}
                              </span>
                            ) : (
                              <span className=" lightText">Select status</span>
                            );
                          }}
                          IconComponent={ExpandMoreIcon}
                        >
                          {statusList.map((status, index) => (
                            <MenuItem
                              key={index}
                              style={{ color: status.status_colour || "black" }}
                              value={status.id}
                            >
                              {status.status_name}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </div>

                <div className="col-md-6">
                  <label htmlFor="billingType" className="form-label">
                    Billing Type
                  </label>
                  <Controller
                    control={control}
                    name="billingType"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          IconComponent={ExpandMore}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Select type</span>
                            )
                          }
                          {...field}
                        >
                          <MenuItem value="BILLABLE">Billable</MenuItem>
                          <MenuItem value="NON_BILLABLE">Non-Billable</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              <div className="bg-white position-absolute bottom-0 py-3  w-100">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Applying..." : "Apply"}
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const AddTaskListComponent = ({
  onApply,
  onClear,
  onCancel,
  ProjectID,
  fetchTasks,
}) => {
  const { isDarkMode } = useTheme();
  // const [budgetOpen, setBudgetOpen] = useState(false);
  // const [ProjectOpen, setProjectOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [milestoneoption, setMilestoneoption] = useState([]);
  const projectId = localStorage.getItem("project_id");

  const fetchRelatedMilestone = async () => {
    try {
      const response = await fetchEntityById(
        "fetchMilestonesByProjectDetails",
        projectId
      );
      // console.log(response, "sreetask");
      if (response?.data) {
        setMilestoneoption(response.data);
      } 
      else {
        console.error("Invalid response data");
      }
    } 
    catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  useEffect(() => {
    fetchRelatedMilestone();
  }, [projectId]);

  const { refetch } = useFetchTaskListsQuery(projectId);
  // console.log("task_list after adding list: ", tasklist);
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      TaskName: "",
      RelatedMilestone: "",
    },
  });

  const addMoreTasList = (e) => {
    e.preventDefault();
    handleSubmit((data) => inviteMoreTasks(data))();
  };

  const inviteMoreTasks = async (data) => {
    const requestData = {
      task_list_name: data.TaskName,
      // milestone_id: data.RelatedMilestone,
    };
    setIsSubmitting(true);
    try {
      // Call the API to create the entity
      await postResource("tasklist", "add", ProjectID, requestData);
      toast.success("Task List created successfully");
      reset();
      fetchTasks();
      refetch();
    }
     catch (error) {
      toast.error(error.message);
    } 
    finally {
      setIsSubmitting(false);
    }
  };

  const onSubmit = async (data) => {
    const requestData = {
      task_list_name: data.TaskName,
      // milestone_id: data.RelatedMilestone,
    };
    setIsSubmitting(true);
    try {
      // Call the API to create the entity
       await postResource(
        "tasklist",
        "add",
        ProjectID,
        requestData
      );
      toast.success("Task List created successfully");
      reset();
      onCancel();
      fetchTasks();
      refetch();
    } 
    catch (error) {
      toast.error(error.message);
    } 
    finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            New Task List
          </div>
        </button>
      </div>

      <div className="bg-white px-4 py-3 ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row">
                <div className="col-md-12">
                  <label htmlFor="TaskName" className="form-label">
                    Task List<span className="text-rgbr-red"> *</span>
                  </label>
                  <TextField
                    id="TaskName"
                    placeholder="Enter Task Title"
                    fullWidth
                    variant="outlined"
                    {...register("TaskName", {
                      required: "Task List Title is required",
                    })} // Add validation rule here
                  />
                  {errors.TaskName && (
                    <span className="errorMsg">{errors.TaskName.message}</span>
                  )}
                </div>
              </div>

              {/* <div className="col-md-12 mt-3">
                <label htmlFor="RelatedMilestone" className="form-label">
                  Related Milestone
                </label>

                <Controller
                  name="RelatedMilestone"
                  control={control}
                  defaultValue={null} // Default to null (no selection)
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={milestoneoption}
                      getOptionLabel={(option) =>
                        typeof option === "object" ? option.name : ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.milestone_id === value
                      }
                      value={
                        milestoneoption.find(
                          (c) => c.milestone_id === field.value
                        ) || null // Display label in the field
                      }
                      onChange={(_, selectedOption) => {
                        field.onChange(
                          selectedOption ? selectedOption.milestone_id : null
                        ); // Set only the ID in the field value
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  )}
                />
              </div> */}

              <div className="bg-white my-4">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Adding Task..." : "Add Task"}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    onClick={addMoreTasList}
                    disabled={isSubmitting}
                  >
                    Add more
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const Tasktab = ({ ProjectID }) => {
  const { isDarkMode } = useTheme();
  const { reset } = useForm();
  const project_id = localStorage.getItem("project_id");
  const [viewMode, setViewMode] = usePersistentFilter("projectTaskViewMode", "list");
  const [boardLoading, setBoardLoading] = useState(false);

  const handleViewModeSwitch = (mode) => {
    if (mode === "board" && viewMode !== "board") {
      setBoardLoading(true);
      setTimeout(() => setBoardLoading(false), 700);
    }
    setViewMode(mode);
  };

  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // console.log("login_user in task:", login_user);
  const { role: login_user_role, id: login_user_id } = login_user;
  // console.log("login_user role in task:", login_user_role);
  // console.log("project_id in task :", project_id);
  // const [expandedRows, setExpandedRows] = useState({});
  
  // This is for row expand until user collase the task list, no automatic collapse table ( solved )
    const [expandedRows, setExpandedRows] = useState(() => {
    try {
      const saved = sessionStorage.getItem(`expanded_tasks_${project_id || ProjectID}`);
      return saved ? JSON.parse(saved) : {};
    } catch (e) {
      return {};
    }
  });
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [filter, setFilter] = usePersistentFilter(
    "projectTaskFilter",
    login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 2 : 6
  );
  const [showGroupNames, setShowGroupNames] = useState("milestone");
  // const [Tasks, setTasks] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const {
    timers,
    activeTimerId,
    isPaused,
    pauseTimer,
    resumeTimer,
    stopTimer,
    cancelTimer,
  } = useTaskTimer();
  const [showTimerPopup, setShowTimerPopup] = useState(false);
  // const [minutes, setMinutes] = useState(0);
  // const [hours, setHours] = useState(0);
  // const [seconds, setSeconds] = useState(0);
  const [checkedRows, setCheckedRows] = useState({}); // Track checked checkboxes
  const [activeComponent, setActiveComponent] = useState("AddTask");
  const navigate = useNavigate();
  const location = useLocation();
  const handleShowFilter = () => {
    setShowFilter(true);
    sessionStorage.setItem("isTaskFilterApplied", false);
  };
  // const handleShowProject = () => setShowProject(true); // Open filter
  const StatusOptions = useSelector(
    (state) => state.selectOptions?.StatusOptions
  );
  const statusNames = StatusOptions.find(
    (status) => status.status_type === "TASK"
  );
  const status_list = statusNames?.status_details?.map((status) => ({
    status_id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));
  const dispatch = useDispatch();

  const fetchtasklistDetails = async () => {
    try {
      const response = await fetchEntityById("tasklistDetails", project_id);
      // console.log(response, "tasklistDetails");
      dispatch(setTasklistDatas(response.data));
    } 
    catch (error) {
      console.error("Error fetching tasklistDetails:", error);
    }
  };
  useEffect(() => {
    fetchtasklistDetails();
  }, [project_id]);

  const [rows, setRows] = useState([]);
  const [boardRows, setBoardRows] = useState([]);

  const handleCheckboxChange = (id) => {
    setCheckedRows((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle checkbox state
    }));
  };
  // const handleStatusChange = (e) => {
  //   console.log("selectedValue in event function :", e);
  // };
  const handleStatusChange = async (value) => {
    // const { namvalue, value } = e.target;
    // console.log("autocomplete_name :", name, value);
    // setIsEditing(false);
    setLoading(true);
    // console.log(
    // ` handle_blur_val  Task ID: ${taskId}, Field: ${name}, Value: ${value}, Owner: ${ownerName}`
    // );

    const requestedData = {
      current_status_id: value,
      // owner: ownerName, // Ensure the owner name is passed
    };

    // console.log("Requested data for update: ", requestedData);

    try {
      const response = await postResource( "task", "update", project_id, requestedData );
      // console.log("Update Response: ", response);
      // fetchtasksDetail();
      if (response) {
        toast.success(response.message);
        // task_activity_status();
        // notification_refetch();
        fetchtasklistDetails();
        // if (refetch && typeof refetch === "function") {
        //   await refetch();
        // }
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleTimerPopup = (value) => {
    console.log("timer_column_value :", value);
    setShowTimerPopup((prev) => !prev);
  };
  // const timerRef = useRef(null);

  // useEffect(() => {
  //   timerRef.current = setInterval(() => {
  //     setSeconds((prevSeconds) => {
  //       if (prevSeconds === 59) {
  //         setMinutes((prevMinutes) => {
  //           if (prevMinutes === 59) {
  //             setHours((prevHours) => prevHours + 1);
  //             return 0;
  //           }
  //           return prevMinutes + 1;
  //         });
  //         return 0;
  //       }
  //       return prevSeconds + 1;
  //     });
  //   }, 1000);

  //   return () => clearInterval(timerRef.current); // cleanup only on unmount
  // }, []);

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      // renderCell: (params) => (
      //   <Box display="flex" alignItems="center">
      //     {params.row.isSubtask && (
      //       <Checkbox
      //         checked={!!checkedRows[params.row.id]} // Ensure boolean value
      //         onChange={() => handleCheckboxChange(params.row.id)}
      //       />
      //     )}
      //     {params.row.isSubtask && checkedRows[params.row.id] && (
      //       <IconButton onClick={(event) => handleMenuOpen(event, params.row)}>
      //         <MoreHorizIcon />
      //       </IconButton>
      //     )}
      //     {params.row.isTask && (
      //       <IconButton onClick={() => toggleExpandRow(params.row.id)}>
      //         {expandedRows[params.row.id] ? (
      //           <ExpandMoreIcon />
      //         ) : (
      //           <ChevronRightIcon />
      //         )}
      //       </IconButton>
      //     )}
      //   </Box>
      // ),
      renderCell: (params) => {
        const row = params.row;
        const hasTaskList =
          row.isTask && Array.isArray(row.subtasks) && row.subtasks.length > 0;

        return (
          <Box display="flex" alignItems="center">
            {params.row.isSubtask && (
              <Checkbox
                checked={!!checkedRows[params.row.id]} // Ensure boolean value
                onChange={() => handleCheckboxChange(params.row.id)}
              />
            )}
            {params.row.isSubtask && checkedRows[params.row.id] && (
              <IconButton
                onClick={(event) => handleMenuOpen(event, params.row)}
              >
                <MoreHorizIcon />
              </IconButton>
            )}
            {hasTaskList && (
              <IconButton onClick={() => toggleExpandRow(params.row.id)}>
                {expandedRows[params.row.id] ? (
                  <ExpandMoreIcon />
                ) : (
                  <ChevronRightIcon />
                )}
              </IconButton>
            )}
          </Box>
        );
      },
    },
    { field: "id", headerName: "ID", width: 100 },
    {
      field: "name",
      // headerName: "Task/Subtask Name",
      headerName: "Task Name",
      width: 200,
      align: "left",

      renderCell: (params) => (
        <Box
          sx={{ cursor: params.row.isSubtask ? "pointer" : "pointer" }}
          onClick={() => {
            if (params.row.isTask) {
              // navigate(`/Subtask/${params.row.id}/subtasks`);
              // navigate(`subTaskList/${params.row.id}`);
              navigate(`/projects/projectDetail/${ProjectID}/subTaskList/${params.row.id}`);
            } else if (params.row.isSubtask) {
              // console.log("params_value :", params);
              // navigate(
              //   `/tasks/${params.row.parentId}/taskdetail/${params.row.id}`
              // );
              const finalProjectId = params.row.project_id || project_id || ProjectID;
              navigate(
                // `/projects/projectDetail/${params.row.project_id}/taskdetail/${params.row.id}`
                `/projects/projectDetail/${finalProjectId}/taskdetail/${params.row.id}`
              );
            }
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "owner",
      headerName: "Owner",
      width: 150,
      renderCell: (params) => {
        const owners = params.row.owners || [];
        const displayValue = params.value;

        const tooltipTitle = owners.length > 0 ? (
          <Box>
            {owners.map((o, index) => (
              <div key={index}>{o.name}</div>
            ))}
          </Box>
        ) : "Unassigned";

        return (
          <Tooltip title={tooltipTitle} arrow>
            <Box sx={{ cursor: "pointer" }}>{displayValue}</Box>
            </Tooltip>
        );
      },
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 200,
    //   renderCell: (params) => {
    //     if (!params.row.isSubtask) return null;

    //     const selectedValue = params.value || ""; // Use ID
    //     console.log("selectedValue :", selectedValue);

    //     const statusOptions = status_list || [];

    //     return (
    //       <Box
    //         sx={{
    //           width: "100%",
    //           height: "100%",
    //           display: "flex",
    //           alignItems: "center",
    //         }}
    //       >
    //         <FormControl fullWidth sx={{ height: "100%" }}>
    //           <Select
    //             value={selectedValue}
    //             onChange={(e) => handleStatusChange(e.target.value)}
    //             IconComponent={ExpandMoreIcon}
    //             displayEmpty
    //             size="small"
    //             sx={{
    //               height: "100%",
    //               "& .MuiSelect-select": {
    //                 display: "flex",
    //                 alignItems: "center",
    //                 height: "100%",
    //                 paddingY: "8px",
    //               },
    //             }}
    //             renderValue={(selected) => {
    //               const selectedStatus = statusOptions.find(
    //                 (status) => status.status_id === selected
    //               );

    //               return selectedStatus ? (
    //                 <span style={{ color: selectedStatus.status_colour }}>
    //                   {selectedStatus.status_name}
    //                 </span>
    //               ) : (
    //                 <span className="lightText">Select status</span>
    //               );
    //             }}
    //           >
    //             {statusOptions.map((status) => (
    //               <MenuItem
    //                 key={status.status_id}
    //                 value={status.status_id} // Use ID here
    //                 sx={{ color: status.status_colour || "black" }}
    //               >
    //                 {status.status_name}
    //               </MenuItem>
    //             ))}
    //           </Select>
    //         </FormControl>
    //       </Box>
    //     );
    //   },
    // },
    // Previous location of Status column (current_status_name) was here
    { field: "startDate", headerName: "Start Date", width: 150 },
    { field: "dueDate", headerName: "Due Date", width: 150 },
    { field: "duration", headerName: "Duration", width: 150 },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 150,

      renderCell: (params) => {
        const status_colour = params.row.status_colour;
        const value = params.value;
        return <Box sx={{ color: status_colour || "black" }}>{value}</Box>;
      },
    },
    {
      field: "priority",
      headerName: "Priority",
      width: 120,
      renderCell: (params) => {
        const status = params.value || "N/A";
        const color = params.row.priority_colour || "var(--text-color)";
        if (params.row.isSubtask) {
          return (
            <Box
              sx={{
                color: color,
                textTransform: "capitalize",
              }}
            >
              {status}
            </Box>
          );
        }
      },
    },
    {
      field: "description",
      headerName: "Description",
      width: 200,
      renderCell: (params) => {
        if (!params.row.isSubtask) return null;
        const text = extractTextFromHTML(params.value);
        if (!text) return "";
        return (
          <Tooltip title={text} arrow>
          <Box
            sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                cursor: "pointer",
                }}
              >
                {text}
            </Box>
            </Tooltip>
        );
      },
    },
    {
      field: "completed_percentage",
      headerName: "Completed %",
      width: 150,
      renderCell: (params) => {
        if (!params.row.isSubtask) return null;
        return <Box>{params.value !== undefined && params.value !== null ? `${params.value}%` : "0%"}</Box>;
      },
    },
        {
      field: "billing_type",
      headerName: "Billable Type",
      width: 150,
      renderCell: (params) => {
        if (!params.row.isSubtask) return null;
        return (
          <Box>
            {params.value || "N/A"}
          </Box>
        );
      },
    },
    {
      field: "added_by_name",
      headerName: "Created By",
      width: 180,
      renderCell: (params) => {
        if (!params.row.isSubtask) return null;
        return <Box>{params.value || "Unknown"}</Box>;
      },
    },
    {
      field: "added_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) => {
        if (!params.row.isSubtask || !params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_name",
      headerName: "Updated By",
      width: 180,
      renderCell: (params) => {
        if (!params.row.isSubtask) return null;
        return <Box>{params.value || "-"}</Box>;
      },
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) => {
        if (!params.row.isSubtask || !params.value) return null;
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    // {
    //   field: "timer",
    //   headerName: "Timer",
    //   with: 150,
    //   renderCell: (params) => {

    //     const value = params.value;
    //     return (
    //       params.row.isSubtask && (
    //         <Box
    //           onClick={() => {
    //             startTimer(params.row);
    //             setShowTimerPopup(true);
    //           }}
    //         >
    //           <CiTimer />
    //         </Box>
    //       )
    //     );
    //   },
    // },
  ];

  const transformResponse = (data) => {
    if (!Array.isArray(data)) {
      // console.error("Expected an array but got:", data);
      return [];
    }
    // console.log("task_data response params_value :", data);

    const rows = [];

    // Handling default task list hierarchy
    data.forEach((taskList) => {
      const parentTask = {
        id: `T${taskList.task_list_id}`,
        name: taskList.task_list_name,
        isTask: true,
        subtasks: [],
      };

      // if (Array.isArray(taskList.tasks)) {
      //   parentTask.subtasks = taskList.tasks.map((task) => {
      const subtasksArray = Array.isArray(taskList.tasks) ? taskList.tasks : (Array.isArray(taskList.data) ? taskList.data : []);
      if (subtasksArray.length > 0) {
        parentTask.subtasks = subtasksArray.map((task) => {
          // Extract owner details
          let ownerDisplay = "Unassigned";
          if (Array.isArray(task.owners) && task.owners.length > 0) {
            ownerDisplay =
              task.owners.length > 1
                ? `${task.owners[0].name} (+${task.owners.length - 1})`
                : task.owners[0].name;
          }

          return {
            id: task.task_id,
            name: task.title,
            title: task.title, // Added for compatibility with SubtaskBoard
            owner: ownerDisplay,
            owners: task.owners,
            added_by: task.added_by,
            added_by_name: task.added_by_name,
            updated_name: task.updated_name,
            current_status_id: task.current_status_id, // Added for compatibility with SubtaskBoard
            status_colour: task.status_colour,
            priority_colour: task.priority_colour,
            billing_type: task.billing_type,
            // status: task.current_status_id || "N/A",
            status: task.current_status_name || "N/A",
            current_status_name: task.current_status_name || "Open",
            startDate: task.start_date
              ? format(new Date(task.start_date), "dd-MM-yyyy")
              : null,
            dueDate: task.end_date
              ? format(new Date(task.end_date), "dd-MM-yyyy")
              : null,
            duration: task.estimated_hours
              ? `${task.estimated_hours} hrs`
              : "N/A",
            priority: task.priority_name,
            priority_name: task.priority_name, // Added for compatibility with SubtaskBoard
            project_id: task.project_id,
            log_hours: task.timelogs,
            isSubtask: true,
            parentId: `T${taskList.task_list_id}`,
            task_list_name: taskList.task_list_name,
            description: task.description || "",
            added_at: task.added_at || null,
            updated_at: task.updated_at || null,
            completed_percentage: task.completed_percentage,
          };
        });
      }

      rows.push(parentTask);
    });

    return rows;
  };

  const fetchSearchedTask = async (searchQuery) => {
    // setLoading(true);
    try {
      const response = await newFilterEntities("tasklist/show", project_id, {
        // search: searchQuery,
        search: searchQuery.trim(),
        view_type_id: filter,
      });

      // console.log("task_search_response:", response.data);

      if (response?.data) {
        const transformedData = transformResponse(response?.data); // Pass `true` for search
        // console.log("Transformed Searched Data:", transformedData);
        setRows(transformedData);
        setBoardRows(transformedData);
      } else {
        setRows([]);
        setBoardRows([]);
      }
    } catch (error) {
      console.error("Failed to fetch tasks:", error);
      setRows([]);
      setBoardRows([]);
    // }finally {
    //   setLoading(false);
    }
  };

  const fetchTasks = async () => {
    setLoading(true);
    const requestData = {
      view_type_id: filter,
      // group_by: "tasklist",
    };
    try {
      const response = await newFilterEntities( "tasklist/show", project_id, requestData);
      // console.log("task_response_scope", response);
      if (response?.data) {
        const transformedData = transformResponse(response?.data);
        // console.log(transformedData, "Transformed Data");
        setRows(transformedData);
        setBoardRows(transformedData);
      } 
      else {
        console.error("Invalid response data");
      }
    } 
    catch (error) {
      console.error("Error fetching new tasks:", error);
    } 
    finally {
      setLoading(false);
      setClearFilter(false);
    }
  };

  useEffect(() => {
    fetchTasks();
    // fetchTasks();
  }, [ProjectID]);

  useEffect(() => {
    // fetchTasks();
    fetchTasks();
  }, [filter, showGroupNames, ProjectID]);
  const toggleExpandRow = (taskId) => {
    // console.log("Expanding task with ID:", taskId); // Debugging

    // This is for row expand until user collase the task list, no automatic collapse table ( solved )
    // setExpandedRows((prev) => ({
      setExpandedRows((prev) => {
      const next = {
        ...prev,
        [taskId]: !prev[taskId],
    // }));
    // This is for row expand until user collase the task list, no automatic collapse table ( solved )
      };
      sessionStorage.setItem(`expanded_tasks_${project_id || ProjectID}`, JSON.stringify(next));
      return next;
    });
  };

  const handleMenuOpen = (event, taskId) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(taskId);
  };
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };
  // const handleView = () => {
    // console.log(`View_task: ${selectedTask}`);
    // navigate(`taskdetail/${selectedTask}`);
    // const newPath = `/projects/projectDetail/${selectedTask?.project_id}/taskdetail/${selectedTask?.id}`;
    // navigate(newPath);

  const handleView = (task) => {

    // const targetTask = task || selectedTask;
     const targetTask = (task && task.id) ? task : selectedTask;

    if (!targetTask) return;
    // const newPath = `/projects/projectDetail/${targetTask.project_id}/taskdetail/${targetTask.id}`;
    // console.log("🔍 navigating to:", newPath);
    
    const finalProjectId = targetTask.project_id || project_id || ProjectID;
    const newPath = `/projects/projectDetail/${finalProjectId}/taskdetail/${targetTask.id}`;
    navigate(newPath, { state: { from: location.pathname } });
    handleMenuClose();
  };

  // const handleViewDitailstab = () => {
    // console.log(`View task on new tab: ${selectedTask}`);
    // const newPath = location.pathname.replace(
    //   /\/projectDetail\/\d+\/tasks$/,
    //   `/projectDetail/taskdetail/${selectedTask?.id}`
    // );
    // const newPath = `/projects/projectDetail/${selectedTask?.project_id}/taskdetail/${selectedTask?.id}`;

  const handleViewDitailstab = (task) => {
    // const targetTask = task || selectedTask;
     const targetTask = (task && task.id) ? task : selectedTask;
    if (!targetTask) return;
    // const newPath = `/projects/projectDetail/${targetTask.project_id}/taskdetail/${targetTask.id}`;
    const finalProjectId = targetTask.project_id || project_id || ProjectID;
    const newPath = `/projects/projectDetail/${finalProjectId}/taskdetail/${targetTask.id}`;
    openInNewTab(newPath);
    handleMenuClose();
  };

  const filterOptions = {
    predefined: [
      { label: "All Tasks", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned Tasks", value: 5 },
      // { label: "Unscheduled Tasks", value: "unscheduled" },
      // { label: "Closed Task Lists", value: "closed_task_lists" },
    ],

    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Closed", value: 7 },
      // { label: "My Overdue & Open", value: "my_overdue_open" },
      { label: "Today's Tasks", value: 8 },
      { label: "Tasks I Follow", value: 9 },
      { label: "Tasks Created By Me", value: 10 },
      // { label: "Assigned Via Pick List", value: "assigned_via_pick_list" },
    ],
  };
  const GroupName = [
    { label: "Milestone", value: "milestone" },
    { label: "Tasklist", value: "tasklist" },
  ];
  const handleFilterChange = (event) => {
    const value = event.target.value;
    // console.log("scope_filter_value", value);

    setFilter(value);
  };
  const handleGroup = (e) => {
    // console.log("handleGroup", e.target.value);

    setShowGroupNames(e.target.value);
  };
  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      await fetchSearchedTask(value);
    } 
    else {
      await fetchTasks();
      // setIssues([]); // Clear projects if search term is empty
    }
  };
  const getFlattenedRows = () => {
    const flattenedRows = [];
    rows?.forEach((row) => {
      flattenedRows.push(row); // Add parent row
      if (expandedRows[row.id]) {
        row.subtasks.forEach((subtask) => {
          if (!subtask.id) {
            console.error("Missing ID in subtask:", subtask);
          }
          flattenedRows.push({ ...subtask });
        });
      }
    });
    return flattenedRows;
  };

  const handleApplyFilter = (filteredData) => {
    const sessionFilteredData = sessionStorage.getItem("task_filter_data");
    const filterDatas = sessionFilteredData ? JSON.parse(sessionFilteredData) : null;
    const selectedTitles = filterDatas?.title || [];

    let filtered = filteredData;
    if (Array.isArray(selectedTitles) && selectedTitles.length > 0) {
      filtered = filteredData.map(tl => {
        const matchingTasks = (tl.tasks || []).filter(t => {
          const currentTitle = t.title || t.task_name || t.subtask_name || "";
          const trimmedCurrent = currentTitle.trim().toLowerCase();
          return selectedTitles.some(st => typeof st === "string" && st.trim().toLowerCase() === trimmedCurrent);
        });
        return {
          ...tl,
          tasks: matchingTasks
        };
      });
    }

    const transform_data = transformResponse(filtered);
    setRows(transform_data);
    setShowFilter(false); // Close filter sidebar
    setClearFilter(true);
  };
  const handleApplyBoardFilter = (filteredData) => {
    const sessionFilteredData = sessionStorage.getItem("board_filter_data");
    const filterDatas = sessionFilteredData ? JSON.parse(sessionFilteredData) : null;
    const selectedTitles = filterDatas?.title || [];

    let filtered = filteredData;
    if (Array.isArray(selectedTitles) && selectedTitles.length > 0) {
      filtered = filteredData.map(tl => {
        const matchingTasks = (tl.tasks || []).filter(t => {
          const currentTitle = t.title || t.task_name || t.subtask_name || "";
          const trimmedCurrent = currentTitle.trim().toLowerCase();
          return selectedTitles.some(st => typeof st === "string" && st.trim().toLowerCase() === trimmedCurrent);
        });
        return {
          ...tl,
          tasks: matchingTasks
        };
      });
    }

    const transform_data = transformResponse(filtered);
    setBoardRows(transform_data);
    setShowFilter(false); // Close filter sidebar
  };

  const handleShowProjects = (component) => {
    setActiveComponent(component); // Set which component to show
    setShowProject(true);
  };

  const handleClearFilter = () => {
    fetchTasks();
    sessionStorage.setItem("isTaskFilterApplied", false);
    sessionStorage.removeItem("task_filter_data");
  };

  const handleClearBoardFilter = () => {
    fetchTasks();
    sessionStorage.setItem("isBoardFilterApplied", false);
    sessionStorage.removeItem("board_filter_data");
  };
  
  useEffect(() => {
    const isTaskApplied = sessionStorage.getItem("isTaskFilterApplied") === "true";
    const isBoardApplied = sessionStorage.getItem("isBoardFilterApplied") === "true";

    if (viewMode === "list") {
      setClearFilter(isTaskApplied);
    } 
    else {
      setClearFilter(isBoardApplied);
    }
  }, [viewMode, rows, boardRows]);

  useEffect(() => {
    sessionStorage.setItem("isTaskFilterApplied", false);
    sessionStorage.removeItem("task_filter_data");
    sessionStorage.setItem("isBoardFilterApplied", false);
    sessionStorage.removeItem("board_filter_data");
  }, []);

  const handleCloseProject = () => setShowProject(false);
  // console.log("rows :", selectedTask);
  const canEditTask = hasTaskPermission(
    selectedTask,
    login_user_id,
    login_user_role
  );
  return (
    <div>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Body className="p-0">
          {activeComponent === "AddTask" && (
            // <AddTaskComponent
            //   onCancel={handleCloseProject}
            //   ProjectID={ProjectID}
            //   fetchTasks={fetchTasks}
            //   // onApply={handleAddTask}
            // />
            <CommonAddTaskTab
              onCancel={handleCloseProject}
              // ProjectID={ProjectID}
              refetchList={fetchTasks}
              path_1="task"
              path_2="add"
            />
          )}
          {activeComponent === "AddTaskList" && (
            <AddTaskListComponent
              onCancel={handleCloseProject}
              ProjectID={ProjectID}
              fetchTasks={fetchTasks}
            />
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {/* Add filter */}
      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {showFilter && (viewMode === "board" ? (
            <SubtaskBoardFilter
              project_id={project_id}
              filter_path="tasklist/show"
              isMilestoneTask={false}
              filterid={filter}
              onApply={handleApplyBoardFilter}
              onClear={handleClearBoardFilter}
              onCancel={() => setShowFilter(false)}
            />
          ) : (
            <TaskFilterComponent
              filterid={filter}
              project_id={project_id}
              filter_path="tasklist/show"
              isMilestoneTask={false}
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
              onApply={handleApplyFilter}
              onClear={() => {
                fetchTasks();
                sessionStorage.setItem("isTaskFilterApplied", false);
                sessionStorage.removeItem("task_filter_data");
              }}
              onCancel={() => setShowFilter(false)}
            />
          ))}
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <Dialog open={showTimerPopup} onClose={() => setShowTimerPopup(false)}>
        <DialogContent>
          {activeTimerId && (
            <>
              <p>Timer running for ID: {activeTimerId}</p>
              <p>
                Hours: {String(timers[activeTimerId]?.hours).padStart(2, "0")},
                Minutes:{" "}
                {String(timers[activeTimerId]?.minutes).padStart(2, "0")},
                Seconds:{" "}
                {String(timers[activeTimerId]?.seconds).padStart(2, "0")}
              </p>
              <Box display="flex" gap={2} mt={2}>
                <Button onClick={pauseTimer} disabled={isPaused}>
                  Pause
                </Button>
                <Button onClick={resumeTimer} disabled={!isPaused}>
                  Resume
                </Button>
                <Button
                  color="error"
                  onClick={() => {
                    stopTimer();
                    setShowTimerPopup(false);
                  }}
                >
                  Stop
                </Button>
                <Button
                  color="error"
                  onClick={() => {
                    cancelTimer();
                    setShowTimerPopup(false);
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>

      <div style={{ padding: "9px 16px" }} className="bg-white">
        {/* <div className="d-flex justify-content-between pb-2">
          <div className="d-flex gap-4 align-items-center">
            <FormControl className="pb-2">
              <Select value={filter} onChange={handleFilterChange} displayEmpty> */}

        <Box
          className="row align-items-center"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "9px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
            mx: 0,
          }}
        >
          <div className="col-12 col-lg-4 col-md-6 d-flex align-items-center gap-3" style={{ paddingLeft: 0 }}>
            <FormControl className="">
              <Select
                value={filter}
                onChange={handleFilterChange}
                displayEmpty
                size="small"
              >
                <ListSubheader className="ps-3 text-rgba-gray">
                  Predefined Views
                </ListSubheader>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}

                <ListSubheader className="ps-3 text-rgba-gray">
                  My Views
                </ListSubheader>
                {filterOptions.myViews.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div
              className="d-flex align-items-center"
              style={{ gap: "4px", alignSelf: "center", marginBottom: "1px" }}
            >
              <Tooltip title="Table View">
                <IconButton
                  onClick={() => handleViewModeSwitch("list")}
                  sx={{
                    backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    width: "75px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    marginRight: '10px',
                    "&:hover": {
                      backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <CiViewList size={18} />
                  Table
                </IconButton>
              </Tooltip>

              <Tooltip title="Board View">
                <IconButton
                  onClick={() => handleViewModeSwitch("board")}
                  sx={{
                    backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    width: "75px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <MdViewQuilt size={18} />
                  Board
                </IconButton>
              </Tooltip>
            </div>
          </div>

          <div className="col-12 col-lg-8 col-md-6 d-flex flex-wrap justify-content-md-end gap-2 align-items-center" style={{ paddingRight: 0 }}>
            <SearchBar
              placeholder="Search tasks"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />
            {/* <button
              className='text-decoration-none border-0 me-4 ms-4 rounded-circle project-icon-bg p-2'
              onClick={handleShowProject}
            >
              <CiCirclePlus className='text-rgbr-blue pro-icon-s' />
            </button> */}
            {clearFilter && (
              <button
                type="button"
                disabled={loading}
                className="addmore_btn"
                onClick={viewMode === "board" ? handleClearBoardFilter : handleClearFilter}
              >
                Clear filter
              </button>
            )}

            <ButtonGroup className="ms-2">
              <Button
                onClick={() => handleShowProjects("AddTask")}
                className="AddButton rounded-start rounded-0"
              >
                Add Task
              </Button>
              <Dropdown>
                <Dropdown.Toggle
                  split
                  className="AddButton py-2 rounded-0 rounded-end"
                  id="dropdown-split-button"
                />
                <Dropdown.Menu>
                  {/* <Dropdown.Item
                      onClick={() => handleShowProjects("AddTask")}
                    >
                      Add Task
                    </Dropdown.Item> */}
                  <Dropdown.Item
                    onClick={() => handleShowProjects("AddTaskList")}
                  >
                    Add Task List
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ButtonGroup>
            {/* )} */}

            <Tooltip title="Filter">
              <IconButton
                onClick={handleShowFilter}
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  width: "39px",
                  height: "39px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                  marginRight: "2px",
                  marginLeft: "10px",
                }}
              >
                <CiFilter className="text-rgbr-blue pro-icon-s" />
              </IconButton>
            </Tooltip>
          </div>
        </Box>

        {loading ? (
          <Loader /> // Display loader while loading
        ) : (
          <div className=" row">
            {viewMode === "list" && (
              <div className="col-12 ">
                <FilterSummaryBox
                  onApply={handleApplyFilter}
                  status_type="TASK"
                  task_filter_id={project_id}
                  // filter_path="/project/filter"
                  filter_path="tasklist/show"
                  has_view_type={true}
                />
              </div>
            )}

            <Box
              style={{
                height: (viewMode === "list" ? rows : boardRows).length === 0 ? 300 : "100%",
                width: "100%",
              }}
            >
              {viewMode === "list" ? (
                <DataGrid
                  rows={getFlattenedRows()}
                  columns={columns}
                  loading={loading}
                  pagination
                  pageSizeOptions={[25, 50, 75, 100]}
                  getRowId={(row) => row.id}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                />
              ) : (
                <>
                  {boardLoading && <Loader />}
                  <SubtaskBoard
                    allTasks={boardRows.flatMap((p) => p.subtasks || [])}
                    onRefresh={fetchTasks}
                    loading={loading}
                    searchTerm={searchTerm}
                    onOpenTask={(task) => {
                      handleView(task);
                    }}
                  />
                </>
              )}

              {/* Menu for Action Button Options */}
              <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
              >
                {/* <MenuItem onClick={handleView}> */}
                <MenuItem onClick={() => handleView()}>
                  <CiViewList className="me-2" color="blue" />
                  View Details
                </MenuItem>
                {/* <MenuItem onClick={handleViewDitailstab}> */}
                <MenuItem onClick={() => handleViewDitailstab()}>
                  {/* <MdViewQuilt className="me-2" color="blue" /> */}
                  <CiViewList className="me-2" color="blue" />
                  View Details in New Tab
                </MenuItem>
                {/* <MenuItem onClick={handleDeleteTask}>
                <DeleteForever color="error" className="me-2" />
                Delete Task
              </MenuItem> */}
              
                {canEditTask && (
                  <div>
                    <CommonDeleteDialog
                      name="Task"
                      refetchList={fetchTasks}
                      handleListClose={handleMenuClose}
                      url="task/delete"
                      id={selectedTask?.id}
                      statusName={selectedTask?.name}
                      logHours={selectedTask?.log_hours}
                      // statusName={rows.find((task)=>task.task_id === selectedTask)?}
                    />
                    <Movetask
                      handleMenuClose={handleMenuClose}
                      login_user_id={login_user_id}
                      selectedTask={selectedTask}
                      path="task/moveTask"
                      project_id={project_id}
                      refetch_list={fetchTasks}
                    />
                    <CommonTaskIssueNameChamge
                      name="Task"
                      path="task/update"
                      selectedTask={selectedTask}
                      setMenuAnchorEl={setMenuAnchorEl}
                      refetch_list={fetchTasks}
                    />
                  </div>
                )}
              </Menu>
            </Box>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tasktab;
